<template>
  <router-link :to="url" class="block focus:outline-none transition duration-150 ease-in-out">
    <div class="flex items-center px-4 py-4 sm:px-6">
      <div class="min-w-0 flex-1 flex items-center">
        <div class="flex-shrink-0">
          <div
            class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green"
          >
            <svg
              class="h-6 w-6 text-white"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
              ></path>
            </svg>
          </div>
        </div>
        <div class="min-w-0 px-4 flex-1  md:grid md:grid-cols-2 md:gap-4">
          <div>
            <div class="text-lg leading-5 font-medium text-gray-900 truncate">
              {{ topic.topic }}
            </div>
            <div
              class="mt-2 flex items-center text-sm leading-5 text-gray-500"
            >
              <!--                    <svg class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">-->
              <!--                      <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />-->
              <!--                      <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />-->
              <!--                    </svg>-->
              <span class="truncate">By {{ topic.userDisplay }}</span>
            </div>
          </div>
          <div class="hidden md:block">
            <div v-if="hasReplies">
              <div
                class="mt-2 flex items-center text-sm leading-5 text-gray-500"
              >
                <!--                      <svg class="flex-shrink-0 mr-1.5 h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor">-->
                <!--                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />-->
                <!--                      </svg>-->
                <span class="text-lg mr-1">{{replies}}</span> Replies
              </div>
              <div
                class="mt-2 flex items-center text-sm leading-5 text-gray-500"
              >
                <!--                      <svg class="flex-shrink-0 mr-1.5 h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor">-->
                <!--                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />-->
                <!--                      </svg>-->
                Last reply by {{ topic.lastReply.userDisplay }} at
                {{ friendlyTime }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <svg
          class="h-5 w-5 text-darkpurple"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            clip-rule="evenodd"
          />
        </svg>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "TopicTableRow",
  props: {
    topic: {
      type: Object,
      required: true
    }
  },
  computed: {
    url() {
      return "/topic/" + this.topic.id;
    },
    hasReplies() {
      return (
        this.topic.lastReply !== null && this.topic.lastReply !== undefined
      );
    },
    friendlyTime() {
      return this.topic.lastReply.timestamp.toDate().toLocaleString();
    },
    replies() {
      if (this.topic.lastReply) {
        return this.topic.lastReply.replyCount || 0
      } else {
        return 0;
      }
    }

  }
};
</script>

<style scoped></style>
